import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';
import moment from 'moment'
import diff from '../../../node_modules/jest-diff/build/index';
import { useHistory } from 'react-router-dom';

const EventItemBlock = styled.li`
    width:${isMobileOnly?"92vw":"402px"};
    padding-left: ${isMobileOnly?"0":"30px"};
    margin-bottom: 60px;
`;

const EventItemPBlock = styled.p`
    margin-bottom: 22px;    
    cursor: pointer;
`;

const EventListItemImg = styled.img`
    border-radius: 4px;
    ${isMobileOnly?`
      width:92vw;
      height:62vw;
    `:`
        min-width: 100%;    
    `};
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    ${!isMobileOnly&&"height: 280px"};
    ${!isMobileOnly&&"width : 372px"};
    vertical-align : middle;
    object-fit: cover;
`;

const EventItemTitlePBlock = styled.p`
    ${isMobileOnly?`
      max-height: 64px;
      text-overflow: ellipsis;
      overflow: hidden;
    `:`
      max-height: 64px;
    `};
    line-height: 32px;
    margin-bottom: 10px;
    //font-size: 14px;
    font-weight: 500;
    text-align: left;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    cursor: pointer;
    font-size: 26px;
    //font-family: 'Noto Sans CJK KR';
    word-break: break-all;
    padding: 0px 20px;
`;

const EventItemDateBlock = styled.div`
        flex: 1;
       color: #999;
       padding: 0px 20px;
       right:0;
       .fromto-splitter {margin: 0 6px;}
       font-family: Montserrat;
        font-size: 12px;
`;

const EventItemFilterBlock = styled.div`
    position: relative;
    //bottom: 1px;
    .filter_flag {
    position: absolute;
    bottom: -12px;
    left: 20px;
    width: fit-content;
    height: 24px;
    padding-top: 6px;
    background: #111;
    //border-top: 1px solid #d9d9d9;
    text-align: left;
    }
    
    .filter_flag em {
        display: inline-block;
        height: 15px;
        margin-left: 10px;
        margin-right: 10px;
        //padding: 0 6px 0 8px;
        font: 12px/1 'Noto Sans CJK KR';
        //font-family: 'Noto Sans CJK KR';
        color: #ffffff;
        line-height: 110%;
        vertical-align: top;
    }

    .filter_flag em:first-child {
        margin-left: 10px;
        background: 0;
    }

    .filter_flag .bar_bb {
        display: inline-block;
        width: 1px;
        height: 8px;
        background: rgba(255,255,255,0.6);
        vertical-align: top;
        margin-top: 2px;
    }
`;

const FinishSpanBlock = styled.span`
    display: inline-block;
    position: relative;
    line-height: 24px;
    padding: 0 10px;
    color: #666;
    border-radius: 12px;
    font-size: 13px;
    margin: 1px auto 1px;
    //width : 42px;
    height : 24px;
    font-family: 'Noto Sans CJK KR';
    border: 1px solid #666;
    font-weight: 400;
    margin-right: 10px;
`;

const EventItem = ({ info }) => {
    const history = useHistory();

    const getFilterFlag = () => {
        if(info !== null && info !== undefined){
            let isLeft = false;
        /* return (<EventItemFilterBlock><div className="filter_flag">{info.is_promo ? <div><em>프로모션</em><span className="bar_bb"></span> <em>브랜드</em></div>: ""}
        {info.is_sale ? (info.is_promo ? <div><span className="bar_bb"></span> <em>세일</em></div>:<em>세일</em> ):""}
        {info.is_brand ? (info.is_promo || info.is_sale ? <div><span className="bar_bb"></span> <em>브랜드</em></div>:<em>브랜드</em> ):""}
        </div></EventItemFilterBlock>) */

        let flag = '<div class="filter_flag"> ';
        if(info.is_promo) {
            flag += '<em>프로모션</em>';
            isLeft = true;
        }

        if(info.is_sale) {
            if(isLeft){
                flag += '<span class="bar_bb"></span>';
            }

            isLeft = true;
            flag += '<em>세일</em>';
        }

        if(info.is_brand) {
            if(isLeft){
                flag += '<span class="bar_bb"></span>';
            }

            flag += '<em>브랜드</em>';
        }

            if(info.is_guide) {
                if(isLeft){
                    flag += '<span class="bar_bb"></span>';
                }

                flag += '<em>가이드</em>';
            }

        flag += '</div>'

        return flag;
        }

        return "<div/>"

    }

    const isFinished = () => {
        if(info !== null && info.end_event_dtm !== null && info.end_event_dtm !== undefined){
            let date = new Date();
            let date1 = new Date(info.end_event_dtm.replace(/-/g, "/"))
            date1.setHours(0,0,0,0);
            date.setHours(0,0,0,0);

            let diffDay = (date.getTime()-date1.getTime())/(1000*60*60*24);

            //console.log("diffday = " + diffDay);
            if(diffDay > 0){
                return true;
            }
        }

        return false;
    }

    const goEvent = () => {
        history.push('/event/'+info.event_cd);
    }

    return (
        <EventItemBlock onClick = {goEvent}>
            <EventItemPBlock>
                <EventListItemImg src={info.event_img} />
                {<EventItemFilterBlock dangerouslySetInnerHTML={{ __html: getFilterFlag() }}/>}
            </EventItemPBlock>
            <div>

            <EventItemTitlePBlock>
                {info.main_title}
            </EventItemTitlePBlock>
            </div>
            <EventItemDateBlock>
                {isFinished() ? <FinishSpanBlock>종료</FinishSpanBlock>:""}
                {info.end_event_dtm ? <span>{moment(info.start_event_dtm).format('YYYY.MM.DD')}<span className="fromto-splitter">-</span>{info.end_event_dtm&&`${moment(info.end_event_dtm).format('YYYY.MM.DD')}`}</span>:''}
            </EventItemDateBlock>
        </EventItemBlock>
    );
};

export default EventItem;
